import React, {useEffect, useState} from 'react';
import {AuthenticatedTemplate, UnauthenticatedTemplate} from "@azure/msal-react";
import {MDBProgress, MDBProgressBar} from "mdb-react-ui-kit";
import {useSelector} from "react-redux";
import Spinner from "../Spinner";

export function JobOverview() {
    const jobCount = useSelector(state => state.jobCount)

    const numberJobsCurrentYear = jobCount.currentJobCountYear
    const numberJobsCompleteYear = jobCount.completeJobCountYear
    const numberJobsTotalYear = numberJobsCurrentYear + numberJobsCompleteYear
    const percentCompleteYear = Math.round((numberJobsCompleteYear / numberJobsTotalYear) * 100)
    const percentLeftYear = 100 - percentCompleteYear;

    const numberJobsCurrentMonth = jobCount.currentJobCountMonth
    const numberJobsCompleteMonth = jobCount.completeJobCountMonth
    const numberJobsTotalMonth = numberJobsCurrentMonth + numberJobsCompleteMonth
    const percentCompleteMonth = Math.round((numberJobsCompleteMonth / numberJobsTotalMonth) * 100)
    const percentLeftMonth = 100 - percentCompleteMonth;

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        //function will run after the component has rendered
        const timer = setTimeout(() => {
            setLoading(false);
        }, 300);

        return () => clearTimeout(timer);
    }, []);

    return (
        <div>
            {loading ? (<Spinner/>) : (
                <div>
                    <UnauthenticatedTemplate>
                        <h5 className="no-access-message"> Sorry, you don't have access to this page! </h5>
                    </UnauthenticatedTemplate>

                    <AuthenticatedTemplate>
                        <div className="page-title-sh26">
                            <h1>Job Overview</h1>
                            <p> Green refers to completed jobs and grey refers to uncompleted jobs</p>
                        </div>
                        <hr/>

                        <br/>

                        <p className="bar-subtitle"> Monthly progress</p>
                        <MDBProgress height='40' className="m-5">
                            <MDBProgressBar animated striped className='bar-primary' width={percentCompleteMonth}
                                            valuemin={0} valuemax={100}>
                                {percentCompleteMonth}%
                            </MDBProgressBar>

                            <MDBProgressBar animated striped className='bar-secondary' width={percentLeftMonth}
                                            valuemin={0} valuemax={100}>
                                {percentLeftMonth}%
                            </MDBProgressBar>
                        </MDBProgress>
                        <p className="bar-subtitle-bottom"> Jobs completed = {numberJobsCompleteMonth} / Total jobs
                            = {numberJobsTotalMonth} </p>

                        <br/>

                        <p className="bar-subtitle"> Yearly progress</p>
                        <MDBProgress height='40' className="m-5">
                            <MDBProgressBar animated striped className='bar-primary' width={percentCompleteYear}
                                            valuemin={0} valuemax={100}>
                                {percentCompleteYear}%
                            </MDBProgressBar>

                            <MDBProgressBar animated striped className='bar-secondary' width={percentLeftYear}
                                            valuemin={0} valuemax={100}>
                                {percentLeftYear}%
                            </MDBProgressBar>
                        </MDBProgress>
                        <p className="bar-subtitle-bottom"> Jobs completed = {numberJobsCompleteYear} / Total jobs
                            = {numberJobsTotalYear}</p>

                        <div className="page-break"></div>
                    </AuthenticatedTemplate>
                </div>
            )}
        </div>
    );
}
